import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from "lodash/fp";
import React from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import { push } from 'react-router-redux';
import { withProps } from "recompose";
import { bindActionCreators, compose } from "redux";
import { routes } from "../../../../../constants";
import { forbidPropagate, getCpdCategory, getCpdHours, getDueDateText, getTaskTypeIcon } from '../../../../../services';
import { Icon, SortableTable } from '../../../../components';
import Loading from '../../../loading';

const columns = [
  {
    name: 'title',
    className: () => 'title',
    display: () => 'Title'
  },
  {
    name: 'cpdCategory',
    className: () => 'cpdCategory',
    display: () => 'CPD Category'
  },
  {
    name: 'cpdHours',
    className: () => 'cpdHours',
    display: () => 'CPD hours'
  },
  {
    name: 'assigner',
    className: () => 'assigner',
    display: () => 'Assigned by'
  },
  {
    name: 'dueDate',
    className: () => 'dueDate',
    display: () => 'Due Date'
  },
  {
    name: 'view-task',
    className: () => 'operations',
    display: () => ''
  }
]

const TasksToCompleteTable = ({
  isFetching,
  rows
}) => (
    <div className='scroll-table'>
      {
        rows.length > 0 ?
          <SortableTable
            className="table--tasks table--tasks-to-complete"
            rows={rows}
            columns={columns} /> :
          isFetching ?
            <Row className='no-gutter top-gap'>
              <Col xs={12} md={6} mdOffset={3} className='boxed'>
                <Loading />
              </Col>
            </Row> :
            <Row className='no-gutter top-gap'>
              <Col xs={12} md={6} mdOffset={3} className='boxed'>
                <div className='complete task--empty-data'>
                  <Icon icon='caddie-the-dog' />
                  <h1>Look at you go!</h1>
                  <p className='no-margin'>
                    You're up to date, with no tasks to complete.
                </p>
                  <p className='no-margin'>
                    Looking to learn more? Checkout your CPD library.
                </p>
                </div>
              </Col>
            </Row>
      }
    </div>
  )

const formatRow = (allCpdCategorys, industryCpdCategory, goTo) => (task) => {
  const dueDate = dateFnsCompat.parse(task.dueDate);
  const { dueDateText, pastDue, payAttention } = getDueDateText(dueDate)

  return {
    'handler': () => goTo(routes.app.tasks.view(task.id)),
    'type': getTaskTypeIcon(task),
    'cpdCategory': getCpdCategory(task, allCpdCategorys, industryCpdCategory),
    'title': <LinkContainer onClick={forbidPropagate} to={routes.app.tasks.view(task.id)}><span>{he.decode(task.name)}</span></LinkContainer>,
    'dueDate': <span className={pastDue ? "past-due" : ""}>{payAttention ? <Icon icon="warning-large" /> : null} {dueDateText}</span>,
    'assigner': <span>{he.decode(task.assigner)}</span>,
    'cpdHours': getCpdHours(task),
    'view-task': <LinkContainer onClick={forbidPropagate} className='pull-right' to={routes.app.tasks.view(task.id)}><Button bsStyle='plain'><Icon icon='chevron-right-large' /></Button></LinkContainer>
  }
}

const mapStateToProps = (state) => ({
  allCpdCategorys: state.cpdCategorys.cpdCategorys,
  industryCpdCategory: state.industry.cpdCategorys
})
const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch)
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({
      data,
      allCpdCategorys,
      industryCpdCategory,
      goTo
    }) => ({
      rows: fp.map(
        formatRow(allCpdCategorys, industryCpdCategory, goTo)
      )(data)
    })
  )
)(TasksToCompleteTable)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/tasks-to-complete-table.js